export default "__VITE_PUBLIC_ASSET__adcda4dd__"